(() => {
  if (customElements.get('compatibility-hierarchy')) return;

  class CompatibilityHierarchy extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const source = this.querySelector('.metafield-rich_text_field');
      if (!source) return;
      const groups = Array.from(source.children).filter((node) => node.tagName === 'UL');
      const stats = { vehicles: 0, notes: 0, globalNotes: 0, empty: 0, preserved: 0 };

      for (const group of groups) {
        const replacement = document.createElement('ul');
        replacement.className = 'compatibility-hierarchy__vehicles';
        let safeGroup = true;
        const groupStats = { vehicles: 0, notes: 0, globalNotes: 0, empty: 0 };

        for (const item of group.children) {
          if (item.tagName !== 'LI') { safeGroup = false; break; }
          let text = '';
          let plain = true;
          for (const node of item.childNodes) {
            if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
            else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') text += '\n';
            else { plain = false; break; }
          }
          const lines = plain ? text.split(/\r\n?|\n/).map((line) => line.trim()).filter(Boolean) : [];
          const original = item.cloneNode(true);
          if (!plain) {
            safeGroup = false;
            break;
          }
          if (!lines.length) {
            original.classList.add('compatibility-hierarchy__empty');
            replacement.append(original);
            groupStats.empty++;
            continue;
          }
          if (/^NOTE\s*:/i.test(lines[0])) {
            original.classList.add('compatibility-hierarchy__global-note');
            replacement.append(original);
            groupStats.globalNotes++;
            continue;
          }

          const entries = [];
          let current;
          let safe = true;
          for (const line of lines) {
            if (/^\d{4}\b/.test(line)) {
              current = { vehicle: line, notes: [] };
              entries.push(current);
            } else if (current && /^-\s*\S/.test(line)) {
              current.notes.push(line.replace(/^-\s*/, ''));
            } else {
              safe = false;
              break;
            }
          }
          if (!safe || !entries.length) {
            safeGroup = false;
            break;
          }

          for (const entry of entries) {
            const vehicle = document.createElement('li');
            const label = document.createElement('strong');
            label.className = 'compatibility-hierarchy__ymm';
            label.textContent = entry.vehicle;
            vehicle.append(label);
            if (entry.notes.length) {
              vehicle.append(document.createTextNode('\n'));
              const notes = document.createElement('ul');
              notes.className = 'compatibility-hierarchy__notes';
              for (const text of entry.notes) {
                const note = document.createElement('li');
                note.textContent = text;
                notes.append(note, document.createTextNode('\n'));
              }
              vehicle.append(notes);
            }
            replacement.append(vehicle, document.createTextNode('\n'));
            groupStats.vehicles++;
            groupStats.notes += entry.notes.length;
          }
        }
        if (safeGroup) {
          group.replaceWith(replacement);
          for (const key of Object.keys(groupStats)) stats[key] += groupStats[key];
        } else {
          stats.preserved += group.children.length;
        }
      }
      this.dataset.enhanced = 'true';
      this.dataset.vehicles = String(stats.vehicles);
      this.dataset.notes = String(stats.notes);
      this.dataset.globalNotes = String(stats.globalNotes);
      this.dataset.emptyEntries = String(stats.empty);
      this.dataset.preservedEntries = String(stats.preserved);
    }
  }

  customElements.define('compatibility-hierarchy', CompatibilityHierarchy);
})();
